import { get } from './fetch';

export const getNotificationEventsReport = (customerCode, notificationType, startDate, endDate) => {
  return get({ endpoint: `api/NotificationEvent/?customerCode=${customerCode}&notificationType=${notificationType}&startDate=${startDate}&endDate=${endDate}` });
};